<template>
    <div class="container pt-4">
        <div class="flex flex-wrap flex-row justify-center">
            <div class="card" v-for="image in images">
                <div class="card-image">
                    <figure class="image is-4by3">
                        <img
                            :src="image.src"
                            @click="openGalleryImage"
                            :id="'featured-' + image.id"
                            :data="'image-' + image.id"
                        />
                    </figure>
                </div>
                <div class="card-content">
                    <div class="content text-center hidden md:block">
                        {{ image.caption }}
                    </div>
                    <div class="content text-center md:hidden">
                        {{ image.caption.substring(0, 29) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["images"],
    methods: {
        openGalleryImage(e) {
            this.$emit("open-modal", e);
        }
    },
    computed: {}
};
</script>
